import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';


/**
 * Expandable and collapsible for facet.
 *
 * @param title The title of the facet.
 * @param children The content of the facet.
 * @param isOpen A boolean that indicates the status of the facet.
 * @param toggleOpen A function that handles open/close behaviour.
 * @return JSX
 */
export function CollapsibleFacet(props) {
  const { title, children, isOpen, toggleOpen } = props;

  return (
    <div className="facet">
      <div className="facet-header" onClick={()=>{toggleOpen()}}>
        <div>{title}</div>
        <div>
          <button className="facet-dropdown">{
            isOpen
            ?
            <FontAwesomeIcon icon={faChevronDown} className="chevron-icon" />
            :
            <FontAwesomeIcon icon={faChevronRight} className="chevron-icon" />}
          </button>
        </div>
      </div>
      {isOpen && <div className="facet-content">{children}</div>}
    </div>
  );
};
